export default {
  install(Vue, options = {}) {
    const STORAGE_KEY = options.key || 'sharedCartData'
    const REQUEST_KEY = 'cartSyncRequest'

    console.log('[CartSync] Plugin loaded')

    // Tab khác yêu cầu sync
    window.addEventListener('storage', function (event) {
      // Khi có tab gửi cart
      if (event.key === STORAGE_KEY && event.newValue) {
        try {
          const cart = JSON.parse(event.newValue)
          sessionStorage.setItem('cart', JSON.stringify(cart))
          if (Vue.prototype.$cart) {
            Object.assign(Vue.prototype.$cart, cart)
          }
          localStorage.removeItem(STORAGE_KEY)
          console.log('[CartSync] Nhận cart từ tab khác')
        } catch (e) {
          console.error('[CartSync] Lỗi khi parse cart:', e)
        }
      }

      // Khi có yêu cầu sync từ tab mới mở
      if (event.key === REQUEST_KEY && event.newValue === '1') {
        console.log('[CartSync] Có tab mới yêu cầu cart')
        setTimeout(() => {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(Vue.prototype.$cart))
          console.log('[CartSync] Gửi lại cart cho tab mới')
        }, 100) // nhỏ delay để tab mới kịp gắn listener
      }
    })

    window.addEventListener('focus', () => {
      const tempCart = localStorage.getItem(STORAGE_KEY)
      if (tempCart) {
        const cart = JSON.parse(tempCart)
        sessionStorage.setItem('cart', tempCart)
        if (Vue.prototype.$cart) {
          Object.assign(Vue.prototype.$cart, cart)
        }
        localStorage.removeItem(STORAGE_KEY)
        console.log('[CartSync] Sync khi tab được focus')
      }
    })

    Vue.prototype.$syncCartToTabs = function () {
      if (this.$cart) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.$cart))
        console.log('[CartSync] Gửi cart sang tab khác')
      }
    }

    // Gửi yêu cầu sync nếu sessionStorage trống
    if (!sessionStorage.getItem('cart')) {
      console.log('[CartSync] Yêu cầu sync cart từ tab khác...')
      localStorage.setItem(REQUEST_KEY, '1')
      setTimeout(() => localStorage.removeItem(REQUEST_KEY), 500) // xóa để tránh lặp
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/session-cart-sync.js